import React, { useContext } from 'react'
import './App.scss'
import ContextWrapper, { AuthContext } from './context'
import {
  BrowserRouter,
  Route,
  Routes,
} from "react-router-dom"
import { HomePage, EventPage, AboutPage, MyProfile, Co2, MyEvents } from "./pages"
import Main from './Main'
import Faq from './pages/Faq'

const NavigatorPage = ({ children, authenticatedOnly }) => {
  const { isUserAuthenticated } = useContext(AuthContext)
  if (authenticatedOnly && !isUserAuthenticated) {
    return (
      <Main>
        {/* TODO localize */}
        <div>Not authenticated</div>
      </Main>
    )
  }
  return (
    <Main>
      {children}
    </Main>
  )
}


function App() {


  return (
    <BrowserRouter>
      <ContextWrapper>
        <div className="app">
          <Routes>
            <Route path="/" element={<NavigatorPage><HomePage /></NavigatorPage>} />
            <Route path="/about" element={<NavigatorPage><AboutPage /></NavigatorPage>} />
            <Route path="/event/:id" element={<NavigatorPage><EventPage /></NavigatorPage>} />
            <Route path="/my-events" element={<NavigatorPage authenticatedOnly><MyEvents /></NavigatorPage>} />
            <Route path="/my-profile" element={<NavigatorPage authenticatedOnly><MyProfile /></NavigatorPage>} />
            <Route path="/co2" element={<NavigatorPage><Co2 /></NavigatorPage>} />
            <Route path="/faq" element={<NavigatorPage><Faq /></NavigatorPage>} />

            <Route path="*" element={<div>404</div>} />
          </Routes>
        </div>
      </ContextWrapper>
    </BrowserRouter>
  )
}

export default App
